// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GrM1","type":"styles_type__1igEk","choices":"styles_choices__1c7WH"};